export default `float de ( vec3 p ) {
  float e,v,u;
  e=v=2.;
  for(int j=0;j++<12;j>3?e=min(e,length(p.xz+length(p)/u*.557)/v),p.xz=abs(p.xz)-.7,p:p=abs(p)-.9)
    v/=u=dot(p,p),
    p/=u,
    p.y=1.7-p.y;
  return e;
}`